module.exports = __webpack_public_path__ + "8ac886d85102eb7029744493986fe57c.pdf";